<template>
  <div class="popup form-popup visible" id="new-customer-popup">
    <div class="popup-box">
      <p class="h2 title line">{{popupData.type === 'add' ? 'Add new' : 'Update' }} customer</p>
      <form action="#" class="form">
        <div class="field" :class="errorClass('company')">
          <label class="field-name">Company</label>
          <input type="text" class="form-control" placeholder="Name of company" v-model="company">
          <span class="error-text" v-if="v$.company.$error">{{errorMessage('company')}}</span>
        </div>
        <div class="field-wrap">
          <div class="field" :class="errorClass('name')">
            <label class="field-name">Contact Name</label>
            <input type="text" class="form-control" placeholder="Type name" v-model="name">
            <span class="error-text" v-if="v$.name.$error">{{errorMessage('name')}}</span>
          </div>
          <div class="field" :class="errorClass('surname')">
            <label class="field-name">Contact Surname</label>
            <input type="text" class="form-control" placeholder="Type surname" v-model="surname">
            <span class="error-text" v-if="v$.surname.$error">{{errorMessage('surname')}}</span>
          </div>
        </div>
        <div class="field" :class="errorClass('email')">
          <label class="field-name">Contact Email</label>
          <input type="email" class="form-control" placeholder="Type email" v-model="email" :disabled="popupData.type === 'edit'">
          <span class="error-text" v-if="v$.email.$error">{{errorMessage('email')}}</span>
        </div>
        <div class="field" :class="errorClass('phone')">
          <label class="field-name">Contact phone number</label>
          <input type="tel" class="form-control" placeholder="Type number" v-model="phone">
          <span class="error-text" v-if="v$.phone.$error">{{errorMessage('phone')}}</span>
        </div>
        <div class="field" :class="errorClass('account')">
          <label class="field-name">Marlink billing account number</label>
          <input type="text" class="form-control" placeholder="Type account number" v-model="account">
          <span class="error-text" v-if="v$.account.$error">{{errorMessage('account')}}</span>
        </div>


        <div class="form-btn-box">
         <span class="btn success no-bg small" @click="closePopup">
          <icon-base width="20" height="21" viewBox="0 0 20 21"><icon-deny/></icon-base>
          <span>Cancel</span>
         </span>
         <button type="button" class="btn success small" @click="actionClick">
           <icon-base width="22" height="21" viewBox="0 0 25 26"><icon-success/></icon-base>
            <span>{{popupData.type === 'add' ? 'CREATE' : 'UPDATE' }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

import {mapMutations, mapActions, mapState} from "vuex"
import IconBase from "../../common/IconBase";
import IconDeny from "../../common/icons/IconDeny";
/*

import IconSuccess from "../../common/icons/IconSuccess";*/
import { useVuelidate } from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import IconSuccess from "../../common/icons/IconSuccess";

export default {
    name: 'customer-form',

    setup () {
        return { v$: useVuelidate() }
    },
    data () {
        return {
            company: '',
            name: '',
            surname: '',
            email: '',
            phone: '',
            account: ''

        }
    },
    validations() {
        return {
            name: {required},
            company: {required},
            surname: {required},
            email: {required,email},
            phone: {required},
            account: {required}
        }
    },
    components: {
        IconSuccess,
        /*IconSuccess, IconDeny, IconBase*/IconDeny, IconBase},

    computed: {
        ...mapState({
            popupData: state => state.popupData,
        }),
    },

    mounted() {
        if (this.popupData.type === 'edit') {
            this.company = this.popupData.item.company;
            this.email = this.popupData.item.email;
            this.phone = this.popupData.item.phone_number;
            this.account = this.popupData.item.billing_cc;
            //this.name = this.popupData.item.contact_person;
            let name = this.popupData.item.contact_person.split(' ');
            this.name = name[0];
            this.surname = name[1];
        }
    },

    methods: {
        ...mapMutations([
            'switchPopup',
            'setPopupComponent'
        ]),
        ...mapActions('customers', [
            'loadCustomers',
        ]),
        errorClass(field) {
            return this.v$[field].$error ? 'error-field' : ''
        },
        errorMessage(field) {
            return this.v$[field].$errors[0].$message
        },
        closePopup() {
            this.switchPopup(false);
        },
        actionClick() {
            this.v$.$touch();

            if (this.v$.$error) {
                return false;
            }

            let params = {
                email: this.email,
                company: this.company,
                billing_cc: this.account,
                phone_number: this.phone,
                contact_person: this.name + ' ' + this.surname
            };
            if (this.popupData.type === 'edit') {
                params.id = this.popupData.item.id;
            }

            this.popupData.func(params).then(() => {
                this.switchPopup(false);
                this.loadCustomers();
            }, () => {
                console.log('errror')
            });

        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
